import { AfterViewInit, Component, Inject, OnInit } from "@angular/core";
import { ItemPedido } from "../../models/pedido";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { PrecificacaoUF } from "../../models/precificacao-uf";
import { FormControl } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { CarregandoService } from "../../services/carregando.service";
import { NotificacaoService } from "../../services/notificacao.service";
import { GlobalService } from "../../services/global.service";
import { PremissasService } from "../../services/premissas.service";
import { CategoriaService } from "../../services/categoria.service";
import { Categoria } from "../../models/categoria";
import { Cliente } from "src/app/models/cliente";
import { TipoFiltroProduto } from "../../models/enum";

declare const $: any;

@Component({
  selector: 'app-produtos-v2-modal',
  templateUrl: './produtos-v2-modal.component.html',
  styleUrls: ['./produtos-v2-modal.component.scss']
})

export class ProdutosV2ModalComponent implements OnInit, AfterViewInit {
  categorias: Categoria[] = [];

  kits: ItemPedido[] = [];
  paineis: ItemPedido[] = [];
  inversores: ItemPedido[] = [];
  stringboxes: ItemPedido[] = [];
  cabos: ItemPedido[] = [];
  estruturas: ItemPedido[] = [];
  outros: ItemPedido[] = [];
  transformadores: ItemPedido[] = [];
  baterias: ItemPedido[] = [];
  mix: ItemPedido[] = [];
  produtos: ItemPedido[] = [];
  fornecedores: number[] = [];
  produtosLoja: ItemPedido[] = [];

  idLoja: number;

  producaoPorPainel;
  quantidadeDePaineis;
  potenciaPainel;
  potTotal;

  potenciaParaFiltrar = 0;
  potenciaParaFiltrarPainel = 0;

  mostrarCabecalho = false;
  situacao = 'A';

  msgAlterarCD;

  familia = 2;
  categoria = 2;

  somenteKit = false;
  somenteEstrutura = false;
  somenteMSK: boolean = false;

  semKit = false;
  semPainel = false;
  semInversor = false;

  mostrarValores = false;
  integrador = false;
  origem: number;
  idFornecedorPainel: number;
  liberado = false;

  //Esta flag diz respeito a selecionar apenas um produto por família
  selecionaSomenteUm = false;
  //Esta flag diz respeito a selecionar apenas um produto independente da família
  selecionaSomenteUmProduto: boolean = false;

  naoMostrarValores = false;
  descAcresPrecificacaoUF: PrecificacaoUF;
  mostrarSomenteFamiliaEspecifica: number = null;

  backup = null;
  backupSelected = null;
  selected = new FormControl(0);

  validaOrigem: boolean = true;

  cliente: Cliente;

  public config: PerfectScrollbarConfigInterface = {};
  public alterouAbaSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(
    public dialogRef: MatDialogRef<ProdutosV2ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private categoriaService: CategoriaService
  ) {
    this.somenteKit = data.somenteKit;
    this.semKit = data.semKit;
    this.semPainel = data.semPainel;
    this.semInversor = data.semInversor;
    this.produtos = data.produtos;
    this.producaoPorPainel = data.producaoPorPainel;
    this.quantidadeDePaineis = data.quantidadeDePaineis;
    this.potenciaPainel = data.potenciaPainel;
    this.potTotal = data.potTotal;

    this.potenciaParaFiltrar = Number(data.potTotal) * 1000;
    this.potenciaParaFiltrarPainel = Number(data.potenciaPainel);
    this.origem = Number(data.origem);

    this.idLoja = data.idLoja;

    if (Number.isNaN(this.origem) || this.origem == null)
      this.validaOrigem = false;

    this.msgAlterarCD = data.msgAlterarCD;
    this.naoMostrarValores = data.naoMostrarValores;
    this.descAcresPrecificacaoUF = data.descAcresPrecificacaoUF;
    this.mostrarSomenteFamiliaEspecifica = data.mostrarSomenteFamiliaEspecifica;
    this.somenteMSK = data.somenteMSK;

    this.cliente = data.cliente;

    if (data.situacao === 'T') {
      this.situacao = '';
    }

    this.somenteEstrutura = data.somenteEstrutura;
    this.selecionaSomenteUm = data.selecionaSomenteUm;
    this.idFornecedorPainel = data.idFornecedorPainel;
    this.mostrarCabecalho = data.mostrarCabecalho;

    this.liberado = true;

    this.selecionaSomenteUmProduto = data.selecionaSomenteUmProduto;
  }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();

    if (this.origem === 3) {

      this.produtosLoja = [...this.produtos];

      this.categorias = [
        {
          id: -1,
          descricao: 'Produtos',
          ativo: 1,
          origens: [],
          origensTexto: '',
          icone: '',
          ordem: 0,
          visivel: true
        }
      ];
    } else {
      this.buscarCategorias().then(c => {
        this.kits = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 7);
        this.paineis = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 2);
        this.inversores = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 3);
        this.stringboxes = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 4);
        this.cabos = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 5);
        this.estruturas = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 6);
        this.outros = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 1);
        this.transformadores = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 8);
        this.baterias = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) === 9);
        this.mix = this.produtos.filter(p => (p.produtoTela.categoria !== 0 ? p.produtoTela.categoria : p.produtoTela.familia) > 9);

        this.categoria = Number(this.categorias[0].id);
      });
    }

    this.buscarVerPrecosProdutos();
    this.alterouAbaSubject.next({ categoria: this.categoria, fornecedores: this.fornecedores });
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarCategorias(): Promise<void> {
    this.carregandoService.mostra('buscaCategorias');

    try {
      const data = await this.categoriaService.listar().toPromise();

      this.categorias = (data || [])
        .map(categoria => {
          let visivel = false;

          if (this.mostrarSomenteFamiliaEspecifica != null) {
            visivel = categoria.id === this.mostrarSomenteFamiliaEspecifica;
          } else {
            const temOrigemValida = categoria.origens &&
              categoria.origens.some(o => o.idOrigem === this.origem);

            let habilitaVisualizacao: boolean;

            if (this.somenteKit) {
              habilitaVisualizacao = categoria.id === 7;
            } else if (this.somenteEstrutura) {
              habilitaVisualizacao = categoria.id === 6;
            } else {
              const mostraKit = !(this.semKit && categoria.id === 7);
              const mostraInversor = !(this.semInversor && categoria.id === 3);
              const mostraPainel = !(this.semPainel && categoria.id === 2);

              habilitaVisualizacao = mostraKit && mostraInversor && mostraPainel;
            }

            visivel = (this.validaOrigem ? temOrigemValida : true) && habilitaVisualizacao;
          }

          return { ...categoria, visivel };
        })
        .filter(categoria => categoria.visivel);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaCategorias');
    }
  }

  ativaAba(cat) {
    this.categoria = cat;
    this.alterouAbaSubject.next({ categoria: this.categoria, fornecedores: this.fornecedores });
  }

  proximo() {
    this.categoria++;
    this.alterouAbaSubject.next({ categoria: this.categoria, fornecedores: this.fornecedores });
  }

  anterior() {
    this.categoria--;
    this.alterouAbaSubject.next({ categoria: this.categoria, fornecedores: this.fornecedores });
  }

  // atualiza as listas de produtos dependendo do tipo
  atualizaLista(lista: ItemPedido[], tipo: number) {
    tipo = Number(tipo);

    switch (tipo) {
      case 1:
        this.outros = lista;
        break;
      case 2:
      case 7:
        this.carregandoService.mostra('TrocouFornecedor');

        if (tipo === 2) {
          this.paineis = lista;
        } else {
          this.kits = lista;
        }

        this.carregandoService.esconde('TrocouFornecedor');
        break;

      case 3:
        this.inversores = lista;
        break;

      case 4:
        this.stringboxes = lista;
        break;

      case 5:
        this.cabos = lista;
        break;

      case 6:
        this.estruturas = lista;
        break;

      case 8:
        this.transformadores = lista;
        break;

      case 9:
        this.baterias = lista;
        break;

      case -1:
        this.produtosLoja = lista;

      default:
        this.mix = lista;
        break;
    }

    if (this.selecionaSomenteUmProduto) {
      const algumProdutoChecado = lista.some(p => p.checado);

      if (algumProdutoChecado) {
        if (!this.backup) {
          this.backup = JSON.stringify(this.categorias);
          this.backupSelected = this.selected.value;
        }

        this.categorias = this.categorias
          .map(c => ({ ...c, visivel: c.id === tipo }))
          .filter(f => f.visivel);
      } else if (this.backup) {
        this.categorias = JSON.parse(this.backup);

        setTimeout(() => {
          this.selected.setValue(this.backupSelected);
        });

        this.backup = null;
        this.backupSelected = null;
      }
    }
  }

  alterouTab(index) {
    this.ativaAba(Number(this.categorias[index].id));
    this.selected.setValue(index);
  }

  // retorna os produtos para quem chamou a tela
  retornaProdutos() {
    // concatena todas as listas e retorna
    this.dialogRef.close(this.outros.concat(this.paineis).concat(this.inversores).concat(this.stringboxes)
      .concat(this.cabos).concat(this.estruturas).concat(this.kits).concat(this.transformadores).concat(this.baterias).concat(this.mix));
  }

  // verifica se alguma lista possui não está vazia
  validar() {
    return this.outros.length > 0 ||
      this.kits.length > 0 ||
      this.paineis.length > 0 ||
      this.inversores.length > 0 ||
      this.stringboxes.length > 0 ||
      this.cabos.length > 0 ||
      this.estruturas.length > 0 ||
      this.transformadores.length > 0 ||
      this.baterias.length > 0 ||
      this.mix.length > 0;
  }

  retornarProdutosPorCategoria(categoria: number) {
    switch (categoria) {
      case 7:
        return this.kits;
        break;
      case 6:
        return this.estruturas;
        break;
      case 5:
        return this.cabos;
        break;
      case 4:
        return this.stringboxes;
        break;
      case 3:
        return this.inversores;
        break;
      case 2:
        return this.paineis;
        break;
      case 1:
        return this.outros;
        break;
      case 8:
        return this.transformadores;
        break;
      case 9:
        return this.baterias;
        break;
      case -1:
        return this.produtosLoja;
      default:
        return this.mix;
    }
  }

  ngAfterViewInit() {
    const elemMainPanel = <HTMLElement>document.querySelector('.mat-dialog-container');

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.wizard-produtos');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    $(window).resize(() => {
      $('.wizard-produtos').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $wizard.find('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $wizard.find('.moving-tab').css({
            'transition': 'transform 0s'
          });
        }, 500);
      });
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  protected readonly TipoFiltroProduto = TipoFiltroProduto;
}
